/**
 * Sculpt page entrypoint — lean, standalone bundle.
 *
 * Unlike about.ts (which imports @/app and therefore every module via the
 * createCycles glob), this page mounts an explicit registry so the bundle
 * ships only the modules the Sculpt page actually uses. No Taxi page
 * transitions here — the page navigates natively.
 *
 * Load dist/pages/sculpt.js on the Sculpt page only (instead of app.js).
 */
// Imported from the leaf files, not the "@/modules/_" barrel: the barrel
// re-exports ./track, which pulls @lib/scroll, which pulls Lenis and the full
// @lib/gsap plugin set. Sculpt uses none of it.
import { runMount, runPageIn } from "@/modules/_/runner";
import { mountModules } from "@/modules/_/mount";

import speakerTicker from "@/modules/speaker-ticker";

const REGISTRY = {
  "speaker-ticker": speakerTicker,
};

class _SculptPage {
  constructor() {
    mountModules(REGISTRY);
    runPageIn();
    runMount();
  }
}

export const SculptPage = new _SculptPage();
